import { RRQueryClientProvider } from "@components/RRQueryClientProvider";
import links from "@links";
import PastEventArea from "./PastEventArea";

export const PastEventAreaContainer = () => {
  return (
    <RRQueryClientProvider>
      <div class="tabs tabs-boxed justify-center">
        <a class="tab" href={links.events}>
          Live Events
        </a>
        <a class="tab tab-active" href={links.pastEvents}>
          Rally On Demand
        </a>
        <a class="tab" href={links.privateEvents}>
          Private Events
        </a>
      </div>
      <PastEventArea />
    </RRQueryClientProvider>
  );
};
